import React, { FC } from 'react';
import { titleize } from 'inflection';
import {
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  useFormContext,
  useWatch
} from 'react-hook-form';

import AttachmentForm from '@buyside/components/presentation/WhitePaperForm/WriteupAndAttachments/Attachments/AttachmentForm/attachmentForm';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import Icon from '@buyside/components/presentation/Icon/icon';
import Link from '@buyside/components/presentation/Link/link';

import { getExtensionIcon, getFilepathExtension } from '@buyside/util/fileHelper';
import { WhitePaperFormInput } from '@buyside/util/researchSubmission';

import styles from './attachmentsStyles.scss';

const AttachmentPreview: FC<{
  index: number;
  remove: UseFieldArrayRemove;
  update: UseFieldArrayUpdate<WhitePaperFormInput, 'attachments'>;
}> = ({ index, remove, update }) => {
  const {
    control,
    formState: { isSubmitting }
  } = useFormContext<WhitePaperFormInput>();

  const attachment = useWatch({ control, name: `attachments.${index}` });

  const { attachmentType, filename, url, researchType } = attachment;

  return (
    <div className={styles.attachmentPreview}>
      <div className={styles.attachmentPreviewInfo}>
        {attachmentType ? (
          <p>
            <strong>{titleize(attachmentType)}</strong>
          </p>
        ) : null}
        <Link className={styles.attachmentPreviewLink} to={url} target="_blank">
          <Icon type={getExtensionIcon(getFilepathExtension(filename))} />
          {filename}
        </Link>
      </div>
      <div className={styles.attachmentPreviewActions}>
        <AttachmentForm
          attachment={attachment}
          onSubmitCallback={values => update(index, values)}
          researchType={researchType}
        />
        <Button
          disabled={isSubmitting}
          onClick={() => remove(index)}
          size={BUTTON_SIZES.SMALL}
          text="Delete"
          type={BUTTON_TYPES.LINK}
        />
      </div>
    </div>
  );
};

export default AttachmentPreview;
